export const PASS_REGEX =
  /^(((?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*[A-Z])(?=.*[a-z]))|((?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z]))|((?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]))).{8,}$/;
export const PASS_REGEX_ERROR_MESSAGE =
  "Votre mot de passe doit contenir au moins 8 caractères et au moins 3 des éléments suivants : <br> - Lettres minuscules (a-z) <br> - Lettres majuscules (A-Z) <br/> - Chiffres (0-9) <br/> - Caractères spéciaux (ex. !@#)}";
export const EMAIL_MATCH_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
